var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container h-full" },
    [
      _c("form-page", {
        ref: "formPage",
        scopedSlots: _vm._u(
          [
            {
              key: "form-bottom",
              fn: function () {
                return [_vm._t("form-bottom")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }